<template>
  <slot />
</template>

<script setup lang="ts">
import { useCatcher } from './useCatcher'

useCatcher()
</script>
